<template>
  <div class="app c-app flex-row align-items-center">
    <div class="cover"></div>

    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="9">
          <CCardGroup>
            <CCard class="p-4 login-container register-container animated zoomIn faster">
              <CCardBody>

                <spinner-ttt :show="loading"></spinner-ttt>

                <CRow style="width: 100%;padding-bottom: 50px;margin-right: 0px; margin-left: 0px">
                  <div class="col-md-12" style="align-content: center;text-align: center;">
                    <img class="navbar-brand-minimized" src="logo/logo.png"  height="70" alt="MIMOTO - Área privada clientes MimoTo">
                  </div>

                  <div class="col-md-12" v-if="productPaid" style="align-content: center;text-align: center;"> 
                    <router-link to="/login">
                      <CButton color="link" class="px-0"> Accede a tu área pesonal</CButton>
                    </router-link>
                  </div>

                </CRow>


                <div class="register-title mb-5 mt-4 text-center">
                <h1 class="text-center">

                  <span v-if="productType == customType">
                    ENHORABUENA, HAS ACEPTADO LA SIGUIENTE CONTRATACIÓN EN MIMOTO PARKING:
                  </span>

                  <span v-if="productType == extraType">
                    ENHORABUENA, HAS ACEPTADO ABONAR EL SIGUIENTE PAGO EN MIMOTO PARKING: 
                  </span>

                  <h3 v-if="productPaid" class="mt-4 text-primary" >Servicio ya abonado.</h3>
              
                </h1>
                </div>

                <CForm class="form-mimoto" style="color:#393939; margin-bottom: 20px;">

                  <p class="datos-producto"> <b v-if="productType">{{ stringUtils.getProductLabel(productType.toLowerCase())    }}</b> </p>

                  <p class="datos-producto">Parking : <b v-if="product && product.parking">{{ product.parking.name }}</b> </p>
                  <p class="datos-producto">Concepto : <b v-if="product">{{ product.custom_text }}</b> </p>

                  <p class="datos-producto" v-if="productType === customType">
                     Estancia : <b v-if="product">Del {{ product.start_datetime | DateTimeDMYhms }} al {{ product.end_datetime | DateTimeDMYhms }}</b> </p>

                  <p class="datos-producto">Importe Total (IVA incl.) :<b v-if="product">{{ product.amount }} €</b> </p>

                  <p >Revisa los datos y si son correctos pulsa sobre PAGAR para finalizar la contratación del servicio. 
                  </p>

                  <div class="terms-container">
                    <div class="text-left recordarme">

                      <input
                      v-model="client.check_conditions"
                      class="styled-checkbox"
                      id="aceptance"
                      type="checkbox"
                      name="check_conditions"
                      style="display: none;"
                      v-validate="'required'"
                      data-vv-validate-on="change"
                      v-bind:invalid-feedback="errors.first('check_conditions')"
                      :class="{ 'is-invalid error': errors.first('check_conditions') }"
                      />

                      <label for="aceptance" translate><b>ENTIENDO Y ACEPTO</b> los <a class="link-terms"
                          href="https://mimotoparking.com/condiciones-contrato/" target="_blank">términos y condiciones</a> tal y como se
                        describe anteriormente y se explica con mayor detalle.</label>

                      <small v-if="errors.first('check_conditions')">
                        <p class="text-danger animated slideInDown faster">Debe aceptar los términos y condiciones. Error en aceptación de términos y
                          condiciones</p>
                      </small>
                    </div>


                    <div class="text-left recordarme">

                      <input
                        v-model="client.check_privacy"
                        class="styled-checkbox"
                        id="privacy"
                        type="checkbox"
                        name="check_privacy"
                        style="display: none;"
                        v-validate="'required'"
                        data-vv-validate-on="change"
                        v-bind:invalid-feedback="errors.first('check_privacy')"
                        :class="{ 'is-invalid error': errors.first('check_privacy') }"
                      />

                      <label for="privacy" translate style="word-wrap:break-word;">
                        <b>ENTIENDO Y ACEPTO</b> el tratamiento de mis datos tal y como se describe anteriormente y
                        se explica con mayor detalle en la <a class="link-terms" href="https://mimotoparking.com/politica-privacidad/"
                          target="_blank">política de privacidad.
                        </a> (Su negativa a facilitarnos la autorización implicará la imposibilidad de tratar sus datos con la finalidad
                        indicada).
                      </label>

                      <small v-if="errors.first('check_privacy')">
                        <p class="text-danger animated slideInDown faster">Debe aceptar la política de privacidad. Error en aceptación de la política de privacidad</p>
                      </small>
                    
                    </div>


                  </div>

                  <p class="invalid-feedback d-block mt-0 mb-3" style="color: red;">
                    {{ message }}
                  </p>

                  <div class="title-container">
                    <button @click.prevent="payProduct" class="btn-login btn" :disabled="error || productPaid" >
                      Pagar
                    </button>
                  </div>

                </CForm>

                  <div class="mt-4 logos-footer">
                    <img class="single-logo" :src="require('@/assets/img/logo-feder.png')" height="60" alt="">
                    <img class="single-logo" :src="require('@/assets/img/logo-ivace-gva.png')" height="50" alt="">
                    <img class="single-logo" :src="require('@/assets/img/sello-eu-75-1-r.png')" height="70" alt="">
                  </div>  

                  <div class="mt-4 terms-container legal">
                    <b>Información básica en protección de datos:</b>
                    Conforme al RGPD y la LOPDGDD, MIMOTO PARKING SL tratará los datos facilitados con la finalidad el servicio prestado. 
                    Siempre que nos lo autorice previamente, enviaremos información relacionada con la actividad ofrecida por MIMOTO PARKING SL. 
                    Podrá ejercer, si lo desea, los derechos de acceso, rectificación, supresión, y demás reconocidos en la normativa mencionada. 
                    Para obtener más información acerca de cómo estamos tratando sus datos, acceda a nuestra <a
                      class="link-terms" href="https://mimotoparking.com/politica-privacidad/" target="_blank">política de
                      privacidad.</a>
                  </div>


              </CCardBody>


            </CCard>

            <div v-html="formSanitized"></div>

            <toast ref="toast"></toast>

          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>


  </div>

</template>


<script>

import { getProductByToken, securePayProduct } from '@/app/shared/global/services/product-service';
import validator from '@/validator';
import stringUtils from "@/app/shared/utils/stringUtils";

// import LoaderRoller from "@/app/shared/components/LoaderRoller";

export default {
  name: 'TpvOrder',
  // components: { LoaderRoller },
  data() {
    return {

      client: {
        check_conditions: false,
        check_privacy: false,
        check_ads: null,
        privacy: null,
      },

      product: null,
      token: null,
      productType: null,

      loading: false,

      status: '',
      message: null,
      error: false,
      stringUtils: stringUtils,
      extraType: 'EXTRA',
      customType: 'CUSTOM',
      // Redsys
      formSanitized: null, 
    }
  },
  created() {
    document.title = 'mimoTo - Confirmar abono';

  },
  async mounted() {

    if (!this.$route.query.productType || !this.$route.query.token) {
       this.$refs.toast.showToast('Se esperaban un producto y un token válidos', null,"error","5000");
       this.message = 'No es posible procesar el pedido. Se esperaban un producto y un token válidos';
       this.error = true;
       return;
    }

    if (this.$route.query.productType) {
      this.productType = this.$route.query.productType;
    }

    if (this.$route.query.token) {
      this.token = this.$route.query.token;
    }

    this.getProduct();

  },
  computed: {

    productPaid() {
       if (this.product) {
          const data = this.product?.payments.filter(item => item.payment?.status === 'PAID');
          return Boolean(data.length);
       }
    }
  },
  methods: {

    async getProduct() {

      try {

        const resp = await getProductByToken(this.productType, this.token);

        if (resp.status !== "success") {
          this.$refs.toast.showToast('Error, inténtalo de nuevo en unos minutos', null, 'error', '5000');
          return
        }

        this.product = resp.data;
        this.client = this.product.client;

        if (this.productPaid) {
           this.$refs.toast.showToast('Servicio ya abonado', null,"success","5000");
        }

      } catch(e) {
        this.$refs.toast.showToast('Error, inténtalo de nuevo en unos minutos', null, 'error', '5000');
      } finally {
        
      }
    },

    payProduct() {

      this.message = null;

      this.$validator.validate().then( async valid => { 

        if (valid) {

          try {

            this.loading = true;

            const resp = await securePayProduct(this.productType, this.product.id);

            if (resp.status !== "success") {
              this.$refs.toast.showToast('Error, inténtalo de nuevo en unos minutos', null, 'error', '5000');
              return
            }

            this.formSanitized = resp.data; // this.$sanitize(resp.data);

            this.$nextTick(() => {
              const formElement = document.getElementById('mimoto_payment_form');
              formElement.submit();
            });

            // Paycomet 
            // window.location.href = resp.data.URL_REDIRECT;
            // window.open(resp.data.URL_REDIRECT, '_blank');

          } catch(e) {
            console.log(e);
            this.$refs.toast.showToast('Error, inténtalo de nuevo en unos minutos', null, 'error', '5000');
          } finally {
            this.loading = false;
          }
        }

      });

    },



  }

}
</script>


<style lang="scss" scoped>
@import '~@/assets/scss/mimoto.scss';

.app {
  width: 100%;
  background-image: url("~@/assets/img/login-background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left top;
  // margin-top: $header;
  position: relative;

  @media (min-width: 768px) {
    min-height: 100vh;
  }

  & > * {
    z-index: 2;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(#a8d7e7, 0.5);//#f3f6f9; #A6C4CE  2d5b83
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0.9;
  }

  .register-title {
    font-family: $varela;
  }

}

.invalid-feedback {
  margin-top: 0.4rem !important;
}

.login {

  @media(max-width: 400px) {

    img {
      height:60px !important;

      display: flex;
      align-items: center;
      justify-content: center;

    }
  }

}

.register-footer-links {
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #3899EC;
  font-family: "MuseoSans-300";
  font-size: 0.87rem;

  a:hover {
    color: #82C91E;
  }
}


.logos-footer {
  width: 100%;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-gap: 2rem;

  // display: flex;
  // justify-content: space-between;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }


  @media (max-width: 541px) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-gap: 2rem;
  }


  .single-logo {
    display: flex;
    justify-content: center;
    align-items: center;
  }

}

.datos-producto {
  font-size: 1.1rem;
}


</style>

